(() => {
  if (window.polightShowroom24) return;
  window.polightShowroom24 = true;

  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 699px)');
  const clamp = value => Math.max(0, Math.min(1, value));
  let roots = [];
  let frame = 0;
  let statusTimer;
  let dimensionsDirty = true;

  function render() {
    frame = 0;
    const currentY = scrollY;
    if (dimensionsDirty) {
      roots.forEach(({ scenes }) => scenes.forEach(scene => {
        const rect = scene.track.getBoundingClientRect();
        scene.top = rect.top + currentY;
        scene.height = rect.height;
        scene.travel = Math.max(1, rect.height - scene.stage.offsetHeight);
      }));
      dimensionsDirty = false;
    }
    roots.forEach(({ root, scenes, nav, grounds }) => {
      if (!reduced.matches) scenes.forEach(({ track, stage, kind, lines, top, height, travel }) => {
        if (top > currentY + innerHeight * 2 || top + height < currentY - innerHeight) return;
        const progress = clamp((currentY - top) / travel);
        if (kind === 'hero') {
          const remaining = Math.pow(1 - progress, 1.4);
          track.style.setProperty('--sr24-hero-scale', (1 + (mobile.matches ? .10 : .18) * remaining).toFixed(5));
          track.style.setProperty('--sr24-hero-y', `${(-1.25 * progress).toFixed(3)}%`);
        } else if (kind === 'cct') {
          track.style.setProperty('--sr24-warm', clamp((progress - .18) / .5).toFixed(5));
        } else {
          const scale = 1 + (mobile.matches ? .65 : 1.4) * Math.pow(1 - progress, 1.55);
          track.style.setProperty('--sr24-scale', scale.toFixed(5));
          track.style.setProperty('--sr24-progress', progress.toFixed(5));
          const a = clamp((progress - .25) / .16);
          const b = clamp((progress - .67) / .16);
          const opacities = [1 - a, a * (1 - b), b];
          lines.forEach((line, i) => {
            line.style.setProperty('--sr24-opacity', (.58 + .42 * opacities[i]).toFixed(4));
          });
        }
      });
      if (nav) {
        const line = nav.offsetHeight * .6;
        // Inner grounds (the windows inside the light visit section) take precedence.
        let ground = 'light';
        grounds.forEach(el => {
          const rect = el.getBoundingClientRect();
          if (rect.top <= line && rect.bottom > line) ground = el.dataset.sr24Ground;
        });
        nav.dataset.ground = ground;
      }
    });
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(render);
  }

  const measure = () => { dimensionsDirty = true; schedule(); };
  const resize = new ResizeObserver(measure);
  function collect() {
    dimensionsDirty = true;
    resize.disconnect();
    roots = Array.from(document.querySelectorAll('[data-sr24-root]')).map(root => {
      root.dataset.motion = reduced.matches ? 'off' : 'on';
      const scenes = ['hero', 'reveal', 'cct'].map(kind => {
        const track = root.querySelector(`[data-sr24-${kind}]`);
        const stage = track?.querySelector(kind === 'reveal' ? '[data-sr24-stage]' : `[data-sr24-${kind}-stage]`);
        if (!track || !stage) return null;
        resize.observe(track);
        resize.observe(stage);
        return { track, stage, kind, lines: Array.from(track.querySelectorAll('[data-sr24-line]')) };
      }).filter(Boolean);
      resize.observe(root);
      return { root, scenes, nav: root.querySelector('[data-sr24-nav]'), grounds: Array.from(root.querySelectorAll('[data-sr24-ground]')) };
    });
    schedule();
  }

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-polight-showroom-code]');
    const root = button?.closest('[data-sr24-root]');
    if (!root) return;
    const request = new CustomEvent('polight:showroom:code-request', {
      bubbles: true,
      cancelable: true,
      detail: { source: button.dataset.source }
    });
    const unhandled = button.dispatchEvent(request);
    if (!unhandled) return;
    const dialog = root.querySelector('[data-sr24-code-dialog]');
    if (dialog) { dialog.showModal(); return; }
    const status = root.querySelector('[data-sr24-status]');
    if (!status) return;
    clearTimeout(statusTimer);
    status.textContent = root.dataset.pendingMessage;
    statusTimer = setTimeout(() => { status.textContent = ''; }, 6500);
  });

  document.querySelectorAll('[data-sr24-code-dialog]').forEach(dialog => {
    dialog.querySelector('[data-sr24-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      document.querySelectorAll('[data-sr24-status]').forEach(status => { status.textContent = ''; });
    }
  });
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', measure, { passive: true });
  addEventListener('pageshow', collect);
  reduced.addEventListener('change', collect);
  mobile.addEventListener('change', collect);
  document.addEventListener('shopify:section:load', collect);
  document.addEventListener('shopify:section:unload', () => queueMicrotask(collect));
  collect();
})();
